// One-image-at-a-time product gallery: --prev/--next/--go commands scroll the snap track; swipe and scroll keep the counter and thumbnails in sync.
class SProductGallery extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.track = this.querySelector('[data-gallery-track]');
    this.slides = this.track ? Array.from(this.track.children) : [];
    this.current = this.querySelector('[data-gallery-current]');
    this.prevButton = this.querySelector('[command="--prev"]');
    this.nextButton = this.querySelector('[command="--next"]');
    this.thumbs = Array.from(this.querySelectorAll('[command="--go"]'));
    this.index = 0;

    this.addEventListener('command', (event) => {
      if (event.command === '--prev') this.go(this.index - 1);
      else if (event.command === '--next') this.go(this.index + 1);
      else if (event.command === '--go') this.go(Number(event.source?.dataset.index || 0));
    }, { signal });

    let frame = 0;
    this.track?.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => this.#syncFromScroll());
    }, { signal, passive: true });

    this.track?.addEventListener('keydown', (event) => {
      const rtl = getComputedStyle(this).direction === 'rtl';
      if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + (rtl ? -1 : 1)); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index + (rtl ? 1 : -1)); }
    }, { signal });

    this.#update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  go(target) {
    if (!this.track || this.slides.length === 0) return;
    const count = this.slides.length;
    const next = (target + count) % count;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const width = this.track.clientWidth;
    const rtl = getComputedStyle(this).direction === 'rtl';
    this.track.scrollTo({ left: (rtl ? -1 : 1) * next * width, behavior: reduce ? 'auto' : 'smooth' });
    this.index = next;
    this.#update();
  }

  #syncFromScroll() {
    const width = this.track.clientWidth || 1;
    const index = Math.round(Math.abs(this.track.scrollLeft) / width);
    if (index !== this.index && index < this.slides.length) {
      this.index = index;
      this.#update();
    }
  }

  #update() {
    if (this.current) this.current.textContent = String(this.index + 1);
    this.slides.forEach((slide, i) => {
      slide.toggleAttribute('inert', i !== this.index);
      slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
    });
    this.thumbs.forEach((thumb, i) => {
      if (i === this.index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('s-product-gallery')) customElements.define('s-product-gallery', SProductGallery);
